<template>
  <div class="change-password account-settings">
    <ModalKim
      v-if="modalActive"
      @close="modalActive = false"
      position="left"
      :mood="!errorCode ? 'happy' : 'sad'"
      :color="!errorCode ? '#27C2F2' : '#F67D88'"
    >
      <template slot="body">
        <h2>{{!errorCode ? $t('account.changePassword.success') : $t('account.changePassword.errors.generic') }}</h2>
        <span v-if="errorCode === 400" v-t.preserve="'auth.resetPassword.error.invalidRequest'" />
        <span v-else-if="errorCode === 403">{{ $t('account.changePassword.errors')[403] }}</span>
        <span v-else-if="!!errorCode" v-t.preserve="'auth.resetPassword.error.generic'" />
      </template>
    </ModalKim>
    <h2>{{ $t('account.changePassword.title') }}</h2>
    <form @submit.prevent="changePassword" novalidate autocomplete="off">
      <pk-input v-model="currentPassword" :placeholder="$t('account.changePassword.placeholders.current')" type="password" :error="$v.currentPassword.$error" />
      <pk-input v-model="newPassword" :placeholder="$t('account.changePassword.placeholders.new')" type="password" :error="$v.newPassword.$error" />
      <pk-input v-model="confirmPassword" :placeholder="$t('account.changePassword.placeholders.confirm')" type="password" :error="$v.confirmPassword.$error" />

      <error-text :active="$v.$error">
        <span v-if="$v.newPassword.$error || $v.currentPassword.$error" v-t.preserve="'auth.resetPassword.error.password'" />
        <span v-else-if="$v.confirmPassword.$error" v-t.preserve="'auth.resetPassword.error.passwordsDontMatch'" />
      </error-text>

      <btn flat :loading="loading" submit>{{ $t('account.changePassword.cta') }}</btn>
    </form>
  </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { ACCOUNT_ROUTE } from '@/router/utils'
import validatorMixin from '@/js/mixins/validator'
import enterProcessorMixin from '@/js/mixins/enterProcessor'
import sabAPI from '@/api/sab'
import { strongPassword } from '@/js/validationUtils'

export default {
  name: 'ChangePassword',
  mixins: [validatorMixin, enterProcessorMixin('changePassword')],
  data: () => ({
    loading: false,
    errorCode: null,
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    modalActive: false,
    modalState: null
  }),
  validations: {
    currentPassword: { required, minLength: minLength(8) },
    newPassword: { required, strongPassword },
    confirmPassword: { required, sameAs: sameAs('newPassword') }
  },
  computed: {
    accountRoute() {
      return ACCOUNT_ROUTE
    }
  },
  methods: {
    async changePassword() {
      this.errorCode = null
      if (!this.isValid()) {
        return
      }

      this.loading = true
      try {
        await sabAPI.changePassword(this.currentPassword, this.newPassword)
        // this.$router.previousRoute.name ? this.$router.back() : this.$router.replace({ name: 'account' })
        this.modalActive = true
        this.modalState = 'success'
      } catch (err) {
        this.modalActive = true
        this.errorCode = err.code
      }

      this.loading = false
    }
  }
}
</script>
